import {
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';

import { SearchService } from '../search/search.service';
import { SearchQueryDef } from '../search/search-query-def';

const MAX_SEARCH_RESULTS = 50;

@Component({
    selector: 'line-multiselect',
    template: `
<!-- Selected lines -->
<div *ngIf="model && model.length > 0">
    <table class="table table-sm table-borderless table-nonfluid">
        <tbody>
            <tr *ngFor="let item of model; let i = index;">
                <td class="icon-cell">
                    <a (click)="removeLine(i)" title="Remove {{'Line' | translate}}">
                        <i class="fa fa-remove remove-item"></i>
                    </a>
                </td>
                <td>
                    {{item.LineName}}
                </td>
            </tr>
        </tbody>
    </table>
</div>

<!-- Line typeahead -->
<climb-indirect-typeahead
        [search]="searchLines"
        [resultFormatter]="lineNameFormatter"
        placeholder="{{'Line' | translate}} name&hellip;"
        (selectItem)="selectLine($event)"></climb-indirect-typeahead>
`,
    styles: [`
        .table {
            margin-bottom: 0.25em;
        }
    `]
})
export class LineMultiselectComponent {
    @Input() model: any[];
    @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private _searchService: SearchService
    ) {
        //
    }

    removeLine(index: number) {
        if (this.model && index >= 0 && index < this.model.length) {
            this.model.splice(index, 1);
        }
        this.modelChange.emit(this.model);
    }

    searchLines = (term: string): Promise<any> => {

        let count = null;
        if (term.length < 3) {
            count = MAX_SEARCH_RESULTS;
        }

        const lineFilter = {
            LineName: term
        };

        const searchQueryDef: SearchQueryDef = {
            entity: 'Lines',
            page: 1,
            size: count,
            sortColumn: 'LineName',
            sortDirection: 'asc',
            filter: lineFilter
        };

        return this._searchService.getEntitiesBySearch(searchQueryDef)
            .then((results: any) => {
                return results.data;
            });
    }

    lineNameFormatter = (value: any) => {
        return value.LineName;
    }

    selectLine(line: any) {
        if (this.model) {
            this.model.push(line);
        } else {
            this.model = [line];
        }

        this.modelChange.emit(this.model);
    }
}
